import {CircularProgress, Typography} from "@material-ui/core";
import React from "react";

export const LoadingWidget = () => {
    return (
        <Typography
            align={"center"}
            style={{
                position: "relative",
                width: "100%",
                alignContent: "center",
                paddingTop: 200,
            }}>
            <CircularProgress color='primary' style={{alignSelf: "center"}}/>
        </Typography>
    )
}